import { SettingStoreGetters } from "@/constants/store/setting/settingStoreConstants";
import { Setting } from "@/dataModel";
import { SettingState } from "@/typings/store/states/SettingStoreState";

export default {
  [SettingStoreGetters.GET_AI_SETTING]: (state: SettingState): Setting | null => state.AI_Setting,
};
